(ns metabase.lib.util.match
  (:refer-clojure :exclude [replace])
  (:require
   [clojure.core.match]
   [metabase.lib.util.match.impl])
  (:require-macros [metabase.lib.util.match]))

(comment clojure.core.match/keep-me
         metabase.lib.util.match/keep-me
         metabase.lib.util.match.impl/keep-me)
